<template>
    <div v-if="!mobile">
        <div :class="{
            'search-container': true,
            }">
            <!-- <form @submit.prevent="toSearch" class="search-form"> -->
                <input 
                    type="search" 
                    :placeholder="isOpen ? '' : 'Search item number or keyword'"
                    class="header-input"
                    v-model="inputValue"
                    ref="input"
                    id="typeAheadSearch-desktop"
                    @focus="open"
                    @blur="closeTypeAhead"
                    aria-label="Search item number or keyword"
                    />
                        <!-- <a v-if="inputValue && inputValue?.length > 0" tabindex="0" @click.prevent="clear" alt="close" class="close"><img src="@icons/closeIcon.svg" alt="close"></a> -->

                        <component id="search-button" :is="inputValue ? Link : 'div'" :onStart="onStart" :onFinish="onFinish" :onSuccess="onSuccess" :href="toSearchHref()" :data="{
                            express: isDealer ? express == true ? 1 : 0 : undefined
                        }" alt="Search" class="search-button">
                            <SearchIcon alt="Magnifying glass" aria-hidden="true"/>
                        </component>

                        <label  v-if="isDealer" for="express" class="express-checkbox-inside">
                            <input type="checkbox" id="express" v-model="express"><p>Express</p>
                        </label>
                        <label  v-if="isDealer" for="express" class="express-checkbox-outside">
                            <input type="checkbox" id="express" v-model="express"><p>Express</p>
                        </label>
            <!-- </form> -->
            
        </div>
        <nav class="account-nav-container" aria-label="Account menu" role="navigation">
            <slot name="accountNav"></slot>
        </nav>
        <!-- SEARCH SUGGESTIONS -->
        <div v-if="isOpen" :class="`search-suggestion-container search-suggestion-container-${isDealer ? 'dealer' : 'guest'}`" @mouseenter="setMouseInTarget(true)" @mouseleave="setMouseInTarget(false)">
                <!-- I COL -->
                <div class="search-suggestion-col-1" v-if="!isSearching">
                    <p class="search-suggestion-title title-s">Popular Searches</p>
                    <ul>
                        <li v-for="(popularSearch, index) in popularSearches" :key="index">
                            <Link :href="toSearchHref(popularSearch.searchQuery)" class="search-suggestion-link" :onSuccess="onSuccess">{{ popularSearch.searchQuery }}</Link></li>
                    </ul>
                </div>
                <div class="search-suggestion-col-1" v-else>
                    <p class="search-suggestion-title title-s">Suggested Searches</p>
                    <ul>
                        
                        <Link :onStart="onStart" :onFinish="onFinish" as="li" :href="toSearchHref(queryItem.token)" v-for="(queryItem, index) in suggestedResults" :key="index"  :onSuccess="onSuccess">
                            <div v-html="toHtml(queryItem)" />
                        </Link>
                        <li v-if="suggestedResults.length == 0"><i>No Suggestions</i></li>
                    </ul>

                    <p class="search-suggestion-title title-s">Related Categories</p>
                    <ul>
                        <Link :onStart="onStart" :onFinish="onFinish" as="li" :href="toCategoryHref(category)" v-for="(category, index) in relatedCategories" :key="index"  :onSuccess="onSuccess">{{ category }}</Link>
                    </ul>
                </div>
        
                <div class="search-suggestion-col-2">
                    <div class="flex-row justify-between" v-if="isSearching">
                        <p class="search-suggestion-title title-s">Related Products</p>
                        <Link class="title-xs" :href="route('product.search.searchTerm', [encodeURIComponent(inputValue)])"  :onSuccess="onSuccess">View All Results</Link>
                    </div>
                    <p class="search-suggestion-title title-s" v-else>Featured Products</p>

                    <div class="search-suggestion-items">
                        <Link :onStart="onStart" :onFinish="onFinish" v-for="result in autocompleteResults" :href="route('productDetail.show', [result.seo_name])" class="search-suggestion-item" :aria-label="result.name" :key="result.id"  :onSuccess="onSuccess">
                            <img :src="result.thumbnailImageUrl ?? comingSoonImages().small" :alt="result.name" >
                            <div class="search-suggestion-item-content">
                                <p class="title-s product-name">{{ result.name }}</p>
                                <div class="product-price-section" v-if="!isDealer">
                                    <p>from</p>
                                    <p class="price">${{ result.price }}</p>
                                </div>
                                <div class="product-price-section" v-else>
                                    <p>View Item to see your pricing</p>
                                </div>
                                <div class="product-variation-section">
                                    <p class="product-color">{{ result.numberOfColors }} color{{ result.numberOfColors > 1 ? 's' : '' }}</p>
                                    <!-- <p class="search-suggestion-badge">Moisture Wicking</p> -->
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
        </div>
    </div>
    <div class="flex-row" v-else>
        <div class="flex-row-forced">
            <input 
                type="search" 
                :placeholder="isOpen ? '' : 'Search item number or keyword'"
                class="header-input"
                v-model="inputValue"
                ref="input"
                id="typeAheadSearch-mobile"
                @focus="open"
                @blur="closeTypeAhead"
                />

                

                <component  :data="{
                        express: isDealer ? express == true ? 1 : 0 : undefined
                    }" :is="inputValue ? Link : 'div'"  :onStart="onStart" :onFinish="onFinish" :onSuccess="onSuccess" :href="toSearchHref()"  alt="Search" class="search-button" aria-hidden="true">
                    <SearchIcon alt="Magnifying glass" />
                </component>
        </div>
        <label v-if="isDealer" for="express" style="width:min-content;">
            <input type="checkbox" id="express" v-model="express"><p>Express</p>
        </label>    
    </div>
</template>
<script lang="ts" setup>
    import { useTypeAheadStore } from "@/store/typeAhead";
    import { ref, computed, watch, inject } from "vue";
    import { Link, router } from "@inertiajs/vue3";
    import { useFocus, useMagicKeys, useElementVisibility } from "@vueuse/core";
    import { storeToRefs } from "pinia";
    import { useSettingsStore } from "@/store/settings";
    import SearchIcon from "@icons/search-icon.svg";
    import { comingSoonImages } from "@/helpers/composables/comingSoonImages"
    import sanitize from "sanitize-html";

    let route = inject("route");
    
    let { setOverlayMessage } = useSettingsStore();
    let { categories } = storeToRefs(useSettingsStore());
    let input = ref(null)

    let mouseInTarget = ref(false);

    let isOutside = computed(() => {
        if(props.mobile || props.mobileTypeaheadDropdown){
            return !mobileMouseTracker.value.typeaheadInput && !mobileMouseTracker.value.typeaheadDropdown;
        }
        return !mouseInTarget.value;
    });

    let setMouseInTarget = (value) => {
        if(props.mobile){
            mobileMouseTracker.value.typeaheadInput = value;
        }else if(props.mobileTypeaheadDropdown){
            mobileMouseTracker.value.typeaheadDropdown = value;
        }else{
            mouseInTarget.value = value;
        }
    };

    let props = defineProps({
        isDealer: {
            type: Boolean,
            default: false
        },
        mobile: {
            type: Boolean,
            default: false
        },
        mobileTypeaheadDropdown: {
            type: Boolean,
            default: false
        }
    });

    let typeAheadStore = useTypeAheadStore();
    let { inputValue, isStyleNumber, popularSearches, isSearching, isOpen, autocompleteResults, suggestedResults, relatedCategories, trueRelatedCategories, express , mobileMouseTracker} = storeToRefs(typeAheadStore);

    let { open, close, toggle, checkIsStyleNumber, formatCategory } = typeAheadStore;

    const toSearchHref = (val = null) => {
        if(!val) {
            val = inputValue.value;
        }
        //replace / character
        val = val.replace(/\//g, "");
        val = encodeURIComponent(val);
        return route("product.search.searchTerm", [val])
    };
    const toSearch = () => {
        let val = inputValue.value;
        let isStyleNumber = checkIsStyleNumber(val);
        if(val == ""){
            return;
        }
        val = val.replace(/\//g, "");
        val = encodeURIComponent(val);
        router.visit(route("product.search.searchTerm", [val]), {
            data: {
                express: props.isDealer ? express.value == true ? 1 : 0  : undefined
            },
            onStart(){
                onStart();
            },
            onSuccess(page){
                onSuccess();
            },
            onFinish(){
                onFinish();
            }
        });
    };

    function toCategoryHref(cat){
        let trueCategory = trueRelatedCategories.value.find((trueCat) =>  formatCategory(trueCat).split(">")?.pop() == cat);
        trueCategory = formatCategory(trueCategory).split(">");
        let href; 
        let cats = categories.value;
        let backendCategory;
        for(let i = 0; i < trueCategory.length; i++){
            backendCategory = cats.find((category) => category.category_name == trueCategory[i]);
            if(i == trueCategory.length -1){
                href = backendCategory?.seo_name ? route("category.show", [backendCategory.seo_name]) : route('404');
            } else {

                cats = backendCategory.child_category ?? [];
            }
        }
        return href;
    }

    const { focused } = useFocus(input);
    const { enter } = useMagicKeys();

    const escapeHtml = (value: string) => {
        return (value ?? "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/\"/g, "&quot;")
            .replace(/'/g, "&#39;");
    };

    const escapeRegExp = (value: string) => {
        return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };

    let toHtml = ({token}: { token: string }) => {
        let sanitizedToken = sanitize(token);
        let sanitizedInput = sanitize(inputValue.value);

        if (!sanitizedInput) {
            return sanitizedToken;
        }

        return sanitizedToken.replace(
            new RegExp(`(${escapeRegExp(sanitizedInput)})`, "gi"),
            (match) => `<strong>${match}</strong>`
        );
    };
    watch(enter, () => {
        console.log("Enter pressed, focused:", focused.value);
        if (focused.value) {
            toSearch();
        }
    });

    function closeTypeAhead() {
        if (isOutside.value) {
            close();
        }
    }

    const isVisible = useElementVisibility(input);
    watch(isVisible, (newVal)=>{
        if(!newVal){
            isOpen.value = false;
            focused.value = false;
        }
    })
    const timeout = ref(); 

    function onStart(){
        closeTypeAhead();
        timeout.value = setTimeout(() => {
            setOverlayMessage("Your search is taking longer than usual. We're working on your request.");
        }, 5000);
    }

    function onFinish(){
        clearTimeout(timeout.value);
        setOverlayMessage(null);
    }

    function onSuccess(){
        close();
        inputValue.value = "";
    }
</script>
<style>
    #typeahead [data-testid="dropdown-content"] {
        width: 75%;
        z-index: 50;
    }
</style>
